import { lazy, Suspense } from "react";
import { homeGalleryImages } from "@/components/gallery/data";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { GalleryHorizontal } from "lucide-react";
import { Skeleton } from "@/components/ui/skeleton";


export function HomeGallery() {
  return (
    <section id="gallery" className="py-12 bg-gray-50">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-primary text-center mb-2">
          Our Recent Projects
        </h2>
        <p className="text-gray-600 text-center mb-6 max-w-2xl mx-auto">
          A selection of our secondary glazing installations across London
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
          {homeGalleryImages.map((image) => (
            <div key={image.id} className="overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="h-48 overflow-hidden">
                <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                    loading="lazy"
                    decoding="async"
                    width={300}
                    height={200}
                  />
              </div>
              <div className="p-3 bg-white">
                <h3 className="font-medium text-primary text-sm">{image.title}</h3>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Link to="/secondary-glazing-images">
            <Button variant="outline" className="flex items-center gap-2">
              <GalleryHorizontal className="h-4 w-4" />
              View Full Gallery
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
